module.exports = __webpack_public_path__ + "static/img/sebastian_pictgrid44_1060x872.16a8b05.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/sebastian_pictgrid44_1060x872.jpg
// module id = Jljm
// module chunks = 0